import React, {useRef, useState, useLayoutEffect} from "react";
import Table from "../Table/Table";
import {Button, Col, OverlayTrigger, Spinner, Tooltip} from "react-bootstrap";
import {TbCopy} from "react-icons/tb";
import PasswordField from "../PasswordField/PasswordField";

export default function CredentialsTable({
                                             showPropertiesWithData,
                                             copyTextToClipboard,
                                             data,
                                             isNoCredentials
                                         }) {
    const wideHeaderStyle = {minWidth: 150, fontSize: 14};
    const colStyle = {minWidth: 100, fontSize: 14, paddingTop: 10, whiteSpace: 'nowrap'};
    const textColStyle = {maxWidth: 100, fontSize: 14, whiteSpace: 'nowrap'};
    const filtersRefs = useRef([]);
    const typeFilterRef = useRef();
    const userFilterRef = useRef();
    const passwordFilterRef = useRef();

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        });
        typeFilterRef.current?.resetFilter();
        userFilterRef.current?.resetFilter();
        passwordFilterRef.current?.resetFilter();
    };

    const typeFormatter = (cell, row) => {
        let data = Object.entries(row.remainingFields).map(([key, value]) => ({key, value}));

        return data.length > 0 ? (
            <Button variant={'link'} onClick={() => showPropertiesWithData(cell, data)} className='p-0 m-0 mt-1'
                    style={{fontWeight: 'bold'}}>{cell}</Button>
        ) : (
            <div className='p-0 m-0 mt-1' style={{fontWeight: 'bold', fontSize: '16px'}}>{cell}</div>
        );
    };

    const Username = ({cell}) => {
        const [showToolTip, setShowToolTip] = useState(false);
        const ref = useRef(null);

        useLayoutEffect(() => {
            if (ref.current.clientWidth < ref.current.scrollWidth) {
                setShowToolTip(true);
            }
        }, [ref]);

        return cell === "" ? <div ref={ref}>{cell}</div> : (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div className={'d-inline-block pr-2'}>
                </div>
                {showToolTip ?
                    <OverlayTrigger placement="right" overlay={<Tooltip> {cell}</Tooltip>}>
                        <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}}
                             className={'d-inline-block'}>
                            {cell}
                        </div>
                    </OverlayTrigger>
                    :
                    <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>
                        {cell}
                    </div>
                }
                <div className={'d-inline-block'}>
                    <Button className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                        <TbCopy onClick={() => copyTextToClipboard(cell)} size={25}/>
                    </Button>
                </div>
            </div>
        );
    };

    const usernameFormatter = (cell) => {
        return (<Username cell={cell}/>);
    };

    const passwordFormatter = (cell, row) => {
        return (<PasswordField value={cell} row={row} copyTextToClipboard={copyTextToClipboard}/>);
    };

    const columns = [
        {
            dataField: 'type',
            text: 'Type',
            headerStyle: wideHeaderStyle,
            formatter: typeFormatter,
            style: colStyle,
            editable: false
        },
        {
            dataField: 'username',
            text: 'User',
            headerStyle: wideHeaderStyle,
            formatter: usernameFormatter,
            style: colStyle,
            editable: false
        },
        {
            dataField: 'password',
            text: 'Password',
            headerStyle: wideHeaderStyle,
            formatter: passwordFormatter,
            style: textColStyle,
            editable: false
        },
    ];

    if (!data?.length && !isNoCredentials) {
        return (<Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>);
    } else {
        return (
            <div>
                <Table
                    data={data}
                    columns={columns}
                    pageSize={15}
                    disablePagination
                    resetFilters={resetFilters}
                />
            </div>
        );
    }
}
